import api from '../api.js';
import { notify } from '../../versa/msgbox.js';

const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (ch) => ({
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	"'": '&#39;'
})[ch]);

/**
 * Faz download de conteúdo base64 retornado pela API.
 */
function downloadBase64(base64Content, filename, mimeType)
{
	const bin = atob(base64Content);
	const arr = new Uint8Array(bin.length);
	for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
	const blob = new Blob([arr], { type: mimeType });
	const a = document.createElement('a');
	a.href = URL.createObjectURL(blob);
	a.download = filename || 'controle-emissao-nf.csv';
	a.click();
	URL.revokeObjectURL(a.href);
}

/**
 * Tela operacional do relatório Controle de emissão de NF (#MT-0568870).
 */
export default async function nfeEmissionControl()
{
	const workarea = document.getElementById('workarea');
	if (!workarea) return;
	workarea.innerHTML = `
		<h2>Controle de emissão de NF</h2>
		<form id="nfe-emission-control" class="form" style="margin-bottom:1rem;">
			<div class="fsb">
				<label>Empresa<sup>*</sup><select id="company_id" required style="width:14rem;"></select></label>
				<label>Data inicial<input id="date_from" type="date"></label>
				<label>Data final<input id="date_to" type="date"></label>
				<label>Status NF<input id="nf_status" type="text" placeholder="Ex.: SEM_NF" style="width:12rem;"></label>
				<label>Referência<input id="reference" type="text" style="width:12rem;"></label>
				<label>Número NF<input id="invoice_number" type="text" style="width:8rem;"></label>
			</div>
			<div class="fsb mtm">
				<button type="button" class="button" id="btn-search">Consultar</button>
				<button type="button" class="button" id="btn-csv">Exportar CSV</button>
				<span id="nfe-count" style="margin-left:1rem;color:#666;"></span>
			</div>
		</form>
		<div id="nfe-result"></div>
	`;
	const companies = await api.call(api.list_companies, '?limit=0');
	const select = workarea.querySelector('#company_id');
	(companies || []).forEach((company) => {
		const opt = document.createElement('option');
		opt.value = company.id;
		opt.textContent = company.nick || company.name || company.id;
		select.appendChild(opt);
	});

	const payload = (format = 'json') => {
		const get = (id) => workarea.querySelector(`#${id}`)?.value?.trim() || '';
		const data = { format };
		['date_from', 'date_to', 'nf_status', 'reference', 'invoice_number'].forEach((key) => {
			const v = get(key);
			if (v) data[key] = v;
		});
		return data;
	};

	const renderRows = (result) => {
		const rows = Array.isArray(result) ? result : (result?.rows || []);
		if (!Array.isArray(rows) || !rows.length) {
			workarea.querySelector('#nfe-result').innerHTML = '<p>Nenhum registro encontrado.</p>';
			return;
		}
		workarea.querySelector('#nfe-result').innerHTML = `
			<table class="view">
				<thead><tr>
					<th>Tipo</th><th>Referência</th><th>NF</th><th>Status NF</th><th>Motivo</th><th>Ação recomendada</th>
				</tr></thead>
				<tbody>${rows.map((row) => `
					<tr>
						<td>${esc(row.type || row.io_type)}</td>
						<td>${esc(row.reference)}</td>
						<td>${esc(row.invoice_number)}</td>
						<td>${esc(row.nf_status_label || row.nf_status)}</td>
						<td>${esc(row.motivo_provavel || row.reason || row.motivo)}</td>
						<td>${esc(row.acao_recomendada || row.recommended_action)}</td>
					</tr>`).join('')}</tbody>
			</table>`;
	};

	workarea.querySelector('#btn-search')?.addEventListener('click', async () => {
		try {
			const company_id = select.value;
			const data = await api.call(api.nfe_emission_control_report, company_id, payload());
			renderRows(data);
			const count = await api.call(api.nfe_emission_control_count, company_id, payload());
			workarea.querySelector('#nfe-count').textContent = `${count?.count ?? 0} registro(s)`;
		} catch (e) {
			notify(e?.message || String(e), 'Controle de emissão de NF');
		}
	});
	workarea.querySelector('#btn-csv')?.addEventListener('click', async () => {
		try {
			const resp = await api.call(api.nfe_emission_control_report, select.value, payload('csv'));
			if (resp?.csv)
				downloadBase64(resp.csv, resp.filename, 'text/csv;charset=utf-8');
			else
				notify('Nenhum CSV retornado.', 'Controle de emissão de NF');
		} catch (e) {
			notify(e?.message || String(e), 'Controle de emissão de NF');
		}
	});
}
